import { combineReducers } from 'redux';

import mutations, * as fromMutations from './mutations/mutations';
import queries, * as fromQueries from './queries/queries';

import type { QueryType } from '@web-platform/shared-universal-types/src/network/requestTypes';
import type { Variables } from '@web-platform/shared-universal-types/src/network/types';
import type { MutationState } from '@web-platform/shared-universal-types/src/redux/state/network/mutations';
import type { NetworkState } from '@web-platform/shared-universal-types/src/redux/state/network/network';
import type { QueryItem } from '@web-platform/shared-universal-types/src/redux/state/network/queries';

export default combineReducers({
  queries,
  mutations,
});

export const getQuery = <QT extends QueryType>(
  state: NetworkState,
  type: QT,
  variables: Variables,
): (QueryItem & { type: QT }) | undefined => fromQueries.get(state.queries, type, variables);

export const getAllMutations = (state: NetworkState): MutationState =>
  fromMutations.getAll(state.mutations);
